import * as React from "react";
import type { SVGProps } from "react";

const getTheme = (theme) => {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
const SvgTwoColorUta = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#F7A600"
      fillRule="evenodd"
      d="M5.75 6.75a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3ZM11 8.25a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0ZM8 12a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0Zm-3.75 3.75a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0Zm8.25-1.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Z"
      clipRule="evenodd"
    />
    <path
      fill={getTheme(props["data-theme"])}
      fillRule="evenodd"
      d="M3 3.25A1.75 1.75 0 0 0 1.25 5v14c0 .966.784 1.75 1.75 1.75h18A1.75 1.75 0 0 0 22.75 19V5A1.75 1.75 0 0 0 21 3.25H3ZM2.75 5A.25.25 0 0 1 3 4.75h18a.25.25 0 0 1 .25.25v4.5H17.5a2.5 2.5 0 0 0 0 5h3.75V19a.25.25 0 0 1-.25.25H3a.25.25 0 0 1-.25-.25V5Zm16.5 6.975a1.125 1.125 0 1 1-2.25 0 1.125 1.125 0 0 1 2.25 0Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgTwoColorUta;
